import React from "react";
import { ToastContainer } from "react-toastify";
import OrderReports from "../../components/Reports/Order/OrderReports";

export const ViewOrderReportPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <OrderReports />
        </div>
      </div>
    </div>
  );
};
